'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SYS_ADMIN = exports.SYS_ADMIN = 'SYS_ADMIN';
var COMPANY_ADMIN = exports.COMPANY_ADMIN = 'COMPANY_ADMIN';
var USER = exports.USER = 'USER';
var REGULATOR = exports.REGULATOR = 'REGULATOR';
var REGULATOR_ADMIN = exports.REGULATOR_ADMIN = 'REGULATOR_ADMIN';
var ANONYMOUS = exports.ANONYMOUS = 'ANONYMOUS';


// WEBPACK FOOTER //
// ./config/permissions/roles.js